var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/models/delivery-method.model.ts
import { z } from "zod";
var DELIVERY_METHOD_KIND = {
  SHIPPING: "shipping",
  PICKUP: "pickup",
  COURIER: "courier",
  EXPRESS_COURIER: "express-courier"
};
var DELIVERY_METHOD_KINDS = [
  DELIVERY_METHOD_KIND.SHIPPING,
  DELIVERY_METHOD_KIND.COURIER,
  DELIVERY_METHOD_KIND.PICKUP,
  DELIVERY_METHOD_KIND.EXPRESS_COURIER
];
var deliveryMethodKindsSchema = z.enum(DELIVERY_METHOD_KINDS);
function resolveDeliveryMethodKinds(deliveryMethodKind, hasAddress) {
  if (deliveryMethodKind === DELIVERY_METHOD_KIND.SHIPPING) {
    return [DELIVERY_METHOD_KIND.SHIPPING];
  }
  if (deliveryMethodKind === DELIVERY_METHOD_KIND.PICKUP) {
    return [DELIVERY_METHOD_KIND.PICKUP];
  }
  if (deliveryMethodKind === DELIVERY_METHOD_KIND.COURIER) {
    return hasAddress ? [DELIVERY_METHOD_KIND.COURIER, DELIVERY_METHOD_KIND.EXPRESS_COURIER] : [DELIVERY_METHOD_KIND.COURIER];
  }
  return void 0;
}
var SHIPPING_PROVIDER = {
  DHL_STANDARD: "dhlStandard",
  DHL_EXPRESS: "dhlExpress",
  GO: "go",
  HERMES: "hermes",
  GLS: "gls",
  FEDEX: "fedex",
  LIEFERANDO: "lieferando",
  UPS: "ups"
};
var SHIPPING_PROVIDERS = [
  SHIPPING_PROVIDER.DHL_STANDARD,
  SHIPPING_PROVIDER.DHL_EXPRESS,
  SHIPPING_PROVIDER.GO,
  SHIPPING_PROVIDER.HERMES,
  SHIPPING_PROVIDER.GLS,
  SHIPPING_PROVIDER.FEDEX,
  SHIPPING_PROVIDER.LIEFERANDO,
  SHIPPING_PROVIDER.UPS
];
var shippingProviderSchema = z.object({
  provider: z.enum(SHIPPING_PROVIDERS),
  enabled: z.boolean().optional().default(false),
  cost: z.coerce.number().min(0, "Cost must be greater than 0").step(0.01).nullable().default(0),
  freeFrom: z.coerce.number().min(0, "Free threshold must be greater than 0").step(0.01).nullable(),
  minDays: z.coerce.number().min(1, "Minimum days must be at least 1").nullable(),
  maxDays: z.coerce.number().min(1, "Maximum days must be at least 1").nullable()
}).superRefine((data, ctx) => {
  if (data.enabled) {
    if (data.cost == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Cost is required when enabled",
        path: ["cost"]
      });
    }
    if (data.minDays == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Minimum days is required when enabled",
        path: ["minDays"]
      });
    }
    if (data.maxDays == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Maximum days is required when enabled",
        path: ["maxDays"]
      });
    }
  }
  if (data.minDays != null && data.maxDays != null) {
    if (data.maxDays < data.minDays) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Maximum days must be greater than or equal to minimum days",
        path: ["maxDays"]
      });
    }
  }
});
var EXPRESS_COURIER_PROVIDER = {
  LIEFERANDO: "lieferando",
  UBER_DIRECT: "uber_direct"
};
var EXPRESS_COURIER_PROVIDERS = [
  EXPRESS_COURIER_PROVIDER.LIEFERANDO,
  EXPRESS_COURIER_PROVIDER.UBER_DIRECT
];
var UBER_DIRECT_MAX_DISTANCE_METERS = 1e4;
var UBER_DIRECT_MAX_BASKET_CENTS = 25e3;
function exceedsUberDirectBasketCap(goodsValueCents) {
  return goodsValueCents > UBER_DIRECT_MAX_BASKET_CENTS;
}
var EXPRESS_COURIER_DAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
];
var expressCourierServiceWindowSchema = z.object({
  day: z.enum(EXPRESS_COURIER_DAYS),
  enabled: z.boolean(),
  from: z.string(),
  to: z.string(),
  shippingClosesAt: z.string().nullish()
});
var DELIVERY_METHOD_PROVIDERS = [
  ...SHIPPING_PROVIDERS,
  EXPRESS_COURIER_PROVIDER.UBER_DIRECT
];
var PICKUP_TYPE_KINDS = {
  SAME_DAY: "same-day",
  NEXT_DAY: "next-day"
};
var PICKUP_TYPES = [
  PICKUP_TYPE_KINDS.SAME_DAY,
  PICKUP_TYPE_KINDS.NEXT_DAY
];
var COURIER_TYPE_KINDS = {
  SAME_DAY: "same-day",
  NEXT_DAY: "next-day"
};
var COURIER_TYPES = [
  COURIER_TYPE_KINDS.SAME_DAY,
  COURIER_TYPE_KINDS.NEXT_DAY
];
var shippingMethodSchema = z.array(shippingProviderSchema).nullish();
var pickupMethodSchema = z.object({
  id: z.string(),
  enabled: z.boolean(),
  pickupType: z.enum(PICKUP_TYPES).nullable(),
  orderBefore: z.string().nullable()
});
var courierMethodSchema = z.object({
  id: z.string(),
  enabled: z.boolean(),
  courierType: z.enum(COURIER_TYPES).nullable(),
  orderBefore: z.string().nullable().transform((val) => val || null),
  cost: z.coerce.number().min(0, "Cost must be greater than or equal to 0").step(0.01).nullable().transform((val) => val || null),
  freeFrom: z.coerce.number().min(0, "Free threshold must be greater than or equal to 0").step(0.01).nullable().transform((val) => val || null)
});
var courierSchemaWithValidation = courierMethodSchema.omit({ id: true }).superRefine((data, ctx) => {
  if (!data.enabled) {
    return;
  }
  if (!data.orderBefore) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Order before time is required",
      path: ["orderBefore"]
    });
  }
  if (!data.cost) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Cost is required",
      path: ["cost"]
    });
  }
});
var deliveryMethodSchema = z.object({
  uuid: z.string(),
  enabled: z.boolean(),
  kind: z.enum(DELIVERY_METHOD_KINDS),
  description: z.string().nullish(),
  cost: z.number().nullish(),
  freeFrom: z.number().nullish(),
  provider: z.enum(DELIVERY_METHOD_PROVIDERS).nullish(),
  minDays: z.number().nullish(),
  maxDays: z.number().nullish(),
  orderBefore: z.string().nullish(),
  type: z.enum(PICKUP_TYPES).or(z.enum(COURIER_TYPES)).nullish(),
  preparationTimeMinutes: z.number().int().nonnegative().nullish(),
  roundTripBufferMinutes: z.number().int().nonnegative().nullish(),
  days: z.array(expressCourierServiceWindowSchema).nullish(),
  expressUnavailableReason: z.enum(["time", "location", "day"]).nullish()
});

export {
  __commonJS,
  __toESM,
  DELIVERY_METHOD_KIND,
  DELIVERY_METHOD_KINDS,
  deliveryMethodKindsSchema,
  resolveDeliveryMethodKinds,
  SHIPPING_PROVIDER,
  SHIPPING_PROVIDERS,
  EXPRESS_COURIER_PROVIDER,
  EXPRESS_COURIER_PROVIDERS,
  UBER_DIRECT_MAX_DISTANCE_METERS,
  UBER_DIRECT_MAX_BASKET_CENTS,
  exceedsUberDirectBasketCap,
  EXPRESS_COURIER_DAYS,
  expressCourierServiceWindowSchema,
  DELIVERY_METHOD_PROVIDERS,
  PICKUP_TYPE_KINDS,
  PICKUP_TYPES,
  COURIER_TYPE_KINDS,
  COURIER_TYPES,
  shippingMethodSchema,
  pickupMethodSchema,
  courierMethodSchema,
  courierSchemaWithValidation,
  deliveryMethodSchema
};
//# sourceMappingURL=chunk-W5JGIVWW.js.map